import { render, staticRenderFns } from "./SharePriceWidget.vue?vue&type=template&id=cad496e4&scoped=true"
import script from "./SharePriceWidget.vue?vue&type=script&lang=js"
export * from "./SharePriceWidget.vue?vue&type=script&lang=js"
import style0 from "./SharePriceWidget.vue?vue&type=style&index=0&id=cad496e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad496e4",
  null
  
)

export default component.exports